module.exports = __webpack_public_path__ + "assets/wix-developers-new-logo.svg?af24cdafc2158a3bc8fa36218d1cc543";